"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericalBoundarySchema = exports.NumericalBoundaryAbsoluteSchema = exports.NumericalBoundaryRangeSchema = exports.NumericalBoundaryRangeModeSchema = exports.NumericalBoundaryMaximumSchema = exports.NumericalBoundaryMinimumSchema = exports.NumericalBoundaryBaseSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristic_1 = require("./BoundaryCharacteristic");
exports.NumericalBoundaryBaseSchema = zod_1.z.object({
    type: zod_1.z.string(),
    characteristic: BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
    nominalValue: zod_1.z.number().optional(),
    variance: zod_1.z.string().optional(),
    useAbsVal: zod_1.z.boolean().optional(),
});
exports.NumericalBoundaryMinimumSchema = exports.NumericalBoundaryBaseSchema.extend({
    type: zod_1.z.literal('minimum'),
    value: zod_1.z.number(),
    valInclusive: zod_1.z.boolean().optional(),
}).describe('A minimum value boundary describes the minimal value of the target characteristic with respect to the relative target.');
exports.NumericalBoundaryMaximumSchema = exports.NumericalBoundaryBaseSchema.extend({
    type: zod_1.z.literal('maximum'),
    value: zod_1.z.number(),
    valInclusive: zod_1.z.boolean().optional(),
}).describe('A maximum value boundary describes the maximal value of the target characteristic with respect to the relative target.');
exports.NumericalBoundaryRangeModeSchema = zod_1.z.enum(['inclusive', 'exclusive']);
exports.NumericalBoundaryRangeSchema = exports.NumericalBoundaryBaseSchema.extend({
    type: zod_1.z.literal('range'),
    rangeMode: exports.NumericalBoundaryRangeModeSchema.optional(),
    minVal: zod_1.z.number(),
    minValIncluded: zod_1.z.boolean().optional(),
    maxVal: zod_1.z.number(),
    maxValIncluded: zod_1.z.boolean().optional(),
}).describe('A range boundary describes the range of values that the target characteristic must stay within with respect to the relative target.');
exports.NumericalBoundaryAbsoluteSchema = exports.NumericalBoundaryBaseSchema.extend({
    type: zod_1.z.literal('absolute'),
    value: zod_1.z.number(),
}).describe('An absolute boundary describes the exact value that the target characteristic must take on with respect to the relative target.');
exports.NumericalBoundarySchema = zod_1.z.discriminatedUnion('type', [
    exports.NumericalBoundaryMinimumSchema,
    exports.NumericalBoundaryMaximumSchema,
    exports.NumericalBoundaryRangeSchema,
    exports.NumericalBoundaryAbsoluteSchema,
]);
//# sourceMappingURL=NumericalBoundary.js.map